import { render, staticRenderFns } from "./addPlayer.vue?vue&type=template&id=65239839&scoped=true&"
import script from "./addPlayer.vue?vue&type=script&lang=ts&"
export * from "./addPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./addPlayer.vue?vue&type=style&index=0&id=65239839&lang=scss&scoped=true&"
import style1 from "./addPlayer.vue?vue&type=style&index=1&id=65239839&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65239839",
  null
  
)

export default component.exports